import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PageItem, SearchRequest, SearchResponse} from './auctions-offer.types';
import {map, Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuctionsSpecialOfferFormRequest} from '../../../shared/model/auctions-special-offer-form-request.model';

@Injectable({
  providedIn: 'root'
})
export class AuctionsOfferService {
  private readonly baseUrl = 'https://api.licytacje.processway.pl/public/listing';
  private readonly formRequestUrl = environment.backendAuctionsSpecialOfferFormRequestUrl;

  constructor(
    private readonly httpClient: HttpClient) {
  }

  search(request: SearchRequest): Observable<PageItem[]> {
    return this.httpClient.post<SearchResponse>(this.baseUrl, request).pipe(
      map((response) => response.pageResponse?.content ?? [])
    );
  }


  sendSpecialOfferContactMessage(payload: AuctionsSpecialOfferFormRequest) {
    return this.httpClient.post(this.formRequestUrl, payload, {observe: 'response', responseType: 'text'});
  }
}
